module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAAbklEQVQ4T43T2w2AMAgF0LKHbmVcp7Hj6FrdA9PURx/Ahe8TSOBCfC4H7TkGUMTXyoE5IVxhKYB/CHAPDTxDBctQwDocsA0bjOGLvz1alyFOuGNBW442fFAZpsMG6XBAMhTQDBXUQ1fMXMF1vsINSHl7o35m7IcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwuxiang/service details_icon_score.png
// module id = 4jS0
// module chunks = 1